<template>
	<a-card class="gameAnalysis">
		<a-form-model layout="inline">
			<a-form-model-item label="游戏名称">
				<a-select style="width: 250px;" placeholder="请选择游戏" optionFilterProp="title" @change="getMethods" v-model="searchForm.gameName">
					<a-select-option value="gofighting">极速挑战</a-select-option>
					<a-select-option value="baseball">棒球小子</a-select-option>
					<a-select-option value="magician">记忆大师</a-select-option>
					<a-select-option value="puffer">河豚蹦蹦</a-select-option>
					<a-select-option value=" killpest">灭虫行动</a-select-option>
					<a-select-option value=" birdMigration">候鸟迁徙</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item>
				<a-range-picker @change="onDateChange" :default-value="pickDate" format="YYYY-MM-DD"/>
			</a-form-model-item>
        </a-form-model>
		<div class="static">
			<div>
				<span>{{ totalCount.userCount }}</span>
				<span>学生人数</span>
			</div>
			<div>
				<span>{{ totalCount.playTimes }}</span>
				<span>游戏次数</span>
			</div>
			<div>
				<span>{{ totalCount.timeConsuming }}</span>
				<span>游戏时长（分）</span>
			</div>
		</div>
		<div class="table">
			<h1>分数分布</h1>
			<a-table
				:columns="scoreColumns"
				:scroll="{y: 350}"
				rowKey="id"
				:pagination="false"
				:loading="scoreTable.tableLoading"
				:dataSource="scoreTable.tableDataSource">
			</a-table>
		</div>
		<div class="table">
			<a-button-group style="margin-bottom:15px;">
                <a-button
					:type="btns.btnType === (index + 1) ? 'primary' : 'default'"
					@click="retainChange(index + 1)"
					:key="index"
					v-for="(item, index) in btns.btnList">
                    {{ item }}
                </a-button>
            </a-button-group>
			<a-table
				v-if="btns.btnType == 1"
				:columns="retainCountColumns"
				:scroll="{y: 350}"
				rowKey="id"
				:pagination="retainCountTable.tablePagination"
				:loading="retainCountTable.tableLoading"
				:dataSource="retainCountTable.tableDataSource">
				<div slot="date" slot-scope="text">
					{{ text.date.split(' ')[0]}}
				</div>
			</a-table>
			<a-table
				v-if="btns.btnType == 2"
				:columns="retainColumns"
				:scroll="{y: 350}"
				rowKey="id"
				:pagination="retainTable.tablePagination"
				:loading="retainTable.tableLoading"
				:dataSource="retainTable.tableDataSource">
				<div slot="day1Rate" slot-scope="text">
					{{ text.day1Rate.toFixed(2) + '%'}}
				</div>
				<div slot="date" slot-scope="text">
					{{ text.date.split(' ')[0]}}
				</div>
				<div slot="day3Rate" slot-scope="text">
					{{ text.day3Rate.toFixed(2) + '%'}}
				</div>
				<div slot="day7Rate" slot-scope="text">
					{{ text.day7Rate.toFixed(2) + '%'}}
				</div>
				<div slot="day30Rate" slot-scope="text">
					{{ text.day30Rate.toFixed(2) + '%'}}
				</div>
			</a-table>
		</div>
		<div class="table">
			<h1>游戏天数分布</h1>
			<a-table
				:columns="gameDataColumns"
				:scroll="{y: 350}"
				rowKey="id"
				:pagination="false"
				:loading="gameDataTable.tableLoading"
				:dataSource="gameDataTable.tableDataSource">
			</a-table>
		</div>
		<div class="table">
			<h1>综合分析</h1>
			<a-table
				:columns="analysisColumns"
				:scroll="{y: 350}"
				rowKey="id"
				:pagination="analysisTable.tablePagination"
				:loading="analysisTable.tableLoading"
				:dataSource="analysisTable.tableDataSource">
				<div slot="date" slot-scope="text">
					{{ text.date.split(' ')[0]}}
				</div>
			</a-table>
		</div>
	</a-card>
</template>

<script>
import {FormatDate, tableRelevant} from "@/pages/projectImpl/js/utils";
import moment from 'moment';
const scoreColumns = [
	{title: '分数段',dataIndex: 'segmentName'},
	{title: '次数',dataIndex: 'count'},
]
const gameDataColumns = [
	{title: '天数',dataIndex: 'segmentName'},
	{title: '学生数',dataIndex: 'count'},
]
const retainCountColumns = [
	{title: '日期',scopedSlots: {customRender: 'date'}},
	{title: '学生人数',dataIndex: 'userCount'},
	{title: '1天后',dataIndex: 'day1'},
	{title: '3天后',dataIndex: 'day3'},
	{title: '7天后',dataIndex: 'day7'},
	{title: '30天后',dataIndex: 'day30'},
]
const retainColumns = [
	{title: '时间',scopedSlots: {customRender: 'date'}},
	{title: '学生人数',dataIndex: 'userCount'},
	{title: '1天后',scopedSlots: {customRender: 'day1Rate'}},
	{title: '3天后',scopedSlots: {customRender: 'day3Rate'}},
	{title: '7天后',scopedSlots: {customRender: 'day7Rate'}},
	{title: '30天后',scopedSlots: {customRender: 'day30Rate'}},
]
const analysisColumns = [
	{title: '日期',scopedSlots: {customRender: 'date'}},
	{title: '最高时长（s）',dataIndex: 'maxTimeConsuming'},
	{title: '时长中位数（s）',dataIndex: 'medianTimeConsuming'},
	{title: '平均时长（s）',dataIndex: 'averageTimeConsuming'},
	{title: '最高分',dataIndex: 'maxSocre'},
	{title: '得分中位数',dataIndex: 'medianSocre'},
	{title: '活跃学生数',dataIndex: 'userTotalCount'},
	{title: '游戏次数',dataIndex: 'playCount'},
	{title: '新增学生数',dataIndex: 'newUserCount'},
]
export default {
    name:'gameAnalysis',
    data(){
        return{
			moment,
			pickDate:[moment(FormatDate(new Date().getTime() - 61 * 24 * 3600 * 1000,"YYYY-MM-DD"), 'YYYY-MM-DD'), moment(FormatDate(new Date().getTime() - 24 * 3600 * 1000, 'YYYY-MM-DD'))],
			searchForm:{
				gameName:'gofighting',
				startTime:undefined,
				endTime:undefined,
			},
			totalCount:{},
			// 分数分布
			scoreColumns,
			scoreTable: tableRelevant.call(this,this.getStatic),
			// 留存
			btns: {
				btnList:['留存数', '留存率'],
				btnType:1
			},
				// 留存数
			retainCountColumns,
			retainCountTable: tableRelevant.call(this,this.getRetentionPageList),
				// 留存率
			retainColumns,
			retainTable: tableRelevant.call(this,this.getRetentionPageList),
			// 游戏天数
			gameDataColumns,
			gameDataTable: tableRelevant.call(this,this.getStatic),
			// 综合分析
			analysisColumns,
			analysisTable: tableRelevant.call(this,this.getComprehensiveStatisticsPageList),
        }
    },
	mounted(){
		this.searchForm.startTime = this.pickDate[0].format("YYYY-MM-DD");
		this.searchForm.endTime = this.pickDate[1].format("YYYY-MM-DD");
		this.getMethods()
	},
	methods:{
		onDateChange(val){
			if(val.length){
				this.searchForm.startTime = val[0].format("YYYY-MM-DD");
				this.searchForm.endTime = val[1].format("YYYY-MM-DD");
			}else{
				this.searchForm.startTime = undefined
				this.searchForm.endTime = undefined
			}
			if(this.searchForm.gameName && val.length){
				this.getMethods()
			}

		},
		// 留存数、留存率
		retainChange(val){
			this.btns.btnType = val
			if(this.searchForm.gameName){
				this.getRetentionPageList(1)
			}

		},
		getMethods(){
			this.getStatic()
			this.getComprehensiveStatisticsPageList()
			this.getRetentionPageList(1)
		},
		getStatic(){
			this.scoreTable.tableLoading = true;
			this.$http.GameAnalysis.getOverview(this.searchForm)
			.then(res =>{
					const {data} = res;
					//分数分布
					this.scoreTable.tableDataSource = data.socreFractionalSegments;
					//游戏天数分布
					this.gameDataTable.tableDataSource = data.playTimesSegmented;
					this.totalCount = data.totalCount;
			}).finally(() => {
        this.scoreTable.tableLoading = false;
      })
		},
		// 综合分析
		getComprehensiveStatisticsPageList(pageIndex){
			let params = {
                ...this.searchForm,
                pageIndex: pageIndex || this.analysisTable.tablePagination.current,
                pageSize: this.analysisTable.tablePagination.pageSize,
            }
			this.analysisTable.tableLoading = true;
			this.$http.GameAnalysis.getComprehensiveStatisticsPageList(params)
			.then(res =>{
					const {data} = res;
					this.analysisTable.tableDataSource = data.items;
					this.analysisTable.tablePagination.total = data.totalCount;
			}).finally(() => {
        this.analysisTable.tableLoading = false;
      })
		},
		// 留存率
		getRetentionPageList(pageIndex){
			let params = {
                ...this.searchForm,
                pageIndex: pageIndex || this.btns.btnType == 1 ? this.retainCountTable.tablePagination.current : this.retainTable.tablePagination.current ,
                pageSize:  this.btns.btnType == 1 ? this.retainCountTable.tablePagination.pageSize : this.retainTable.tablePagination.pageSize,
            }
			this.retainCountTable.tableLoading = true;
			this.retainTable.tableLoading = true;
			this.$http.GameAnalysis.getRetentionPageList(params)
			.then(res =>{
					const {data} = res;
					this.retainCountTable.tableDataSource = data.items;
					this.retainCountTable.tablePagination.total = data.totalCount;
					this.retainTable.tableDataSource = data.items;
					this.retainTable.tablePagination.total = data.totalCount;
			}).finally(() => {
        this.retainCountTable.tableLoading = false;
        this.retainTable.tableLoading = false;
      })
		},
	},
}
</script>

<style scoped lang="less">
.static{
	display: flex;
	justify-content: space-around;
	margin-top: 30px;
}
.static div{
	display: flex;
	flex-direction: column;
	align-items: center;
	font-size: 20px;
	font-weight: 600;
	color: #000;
}
.table{
	margin-top: 30px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	padding: 20px;
}
.table h1{
	font-size: 18px;
	font-weight: 600;
	color: #000;
}
</style>
